import getPartnerId from './get-partner-id';

export default {
  getPartnerId,
};
